<template>
  <div class="row mb-4">
    <div class="col text-center">
      <button class="btn btn-md btn-warning center" type="button" @click="logout()"><i class="fa fa-sign-in"></i>Logout</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {

  methods: {
    ...mapActions(
      {
        storeLogout: 'auth/logout'
      }
    ),

    logout () {
      this.storeLogout()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/logout.vue